import ENUM_LIST_BY_NAME from './enumListByName.graphql'
export default ENUM_LIST_BY_NAME
